import { APP_COLOR, APP_HOVER_COLOR } from "../../theme";
import { FONT_FAMILY } from "../../theme";

export const styles = {
  button: {
    textTransform: "none",
    color: 'black',
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  mainContainer: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  loadingContainer: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
};
